import download from 'downloadjs';
import { setMaskGeneric, getPermission, convertDateToAmericanFormat, showMessageError } from '../../../classes/functions';
import { useState, useEffect} from 'react';
import api from '../../../config.js';
import './movements.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import { FaArrowLeft, FaArrowRight, FaCog } from 'react-icons/fa';
import {RiArrowUpDownLine} from 'react-icons/ri'
import ReactTooltip from "react-tooltip";
import { format } from 'date-fns';
import ProductsInput from '../../../components/Inputs/ProductsInput.js';
import InputDate from '../../../components/Inputs/Date/index.js';

export default function Movements(){
  const averageCoastIsAllowed = getPermission("CADASTROS - CUSTO MEDIO");
  const [list, setList] = useState([]);
  const [listAll, setListAll] = useState([]);
  const [labels, setLabels] = useState([]);
  const [indexes, setIndexes] = useState([]);
  const [qtdePage, setQtdePage] = useState(100);
  const [limitPage, setLimitPage] = useState();
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState();
  const [search_main_code_de, setSearchMainCodeDe] = useState('');
  const [search_main_code_ate, setSearchMainCodeAte] = useState('ZZZZZZZZZZ');
  const [search_sub_code_de, setSearchSubCodeDe] = useState('');
  const [search_sub_code_ate, setSearchSubCodeAte] = useState('ZZZZZZZZZZ');
  const [print_coast, setPrintCoast] = useState(averageCoastIsAllowed ? '' : 'N');
  const [productsFrom, setProductsFrom] = useState([]);
  const [productsUntil, setProductsUntil] = useState([]);
  const [itemForSorting, setItemForSorting] = useState([]);
  const [sortingType, setSortingType] = useState([]);
  const [labelsByList, setLabelsByList] = useState([]);
  const [filters, setFilters] = useState({
    produtoDe: '',
    produtoAte: '',
    dataDe: '',
    dataAte: ''
  });

  const [carrying, setCarrying] = useState(true);

  useEffect(()=> {

    async function loadMovements(){
      setCarrying(false);
    }
    
    loadMovements();

    return () => {

    }
  }, []);

  function validForm() {
    if ((filters.dataDe != '') && (filters.dataAte != '')) {
      return true;
    } else {
      toast.error('Preencha todos os campos com * antes de salvar.');
      return false;
    }
  }

  function setLastPage(aux_qtde, aux_qtdePage) {
    let lastPageIndex = parseInt(aux_qtde / aux_qtdePage);

    if ((aux_qtde % aux_qtdePage) > 0) {
      setLimitPage(lastPageIndex + 1);
    } else {
      setLimitPage(lastPageIndex);
    }
  }
  
  function search () {
    setCarrying(true);
    if (!validForm()) {
      setCarrying(false);
      return false;
    }

    let data = {
      data: {
        product_de: filters.produtoDe.split('-')[0].trim(),
        product_ate: filters.produtoAte.split('-')[0].trim(),
        main_code_de: search_main_code_de,
        main_code_ate: search_main_code_ate,
        sub_code_de: search_sub_code_de,
        sub_code_ate: search_sub_code_ate,
        date_de: filters.dataDe,
        date_ate: filters.dataAte,
        print_coast: print_coast,
        page: page,
        qtdePage: qtdePage,
      }
    };

    api.post("/api/movements/search", data)
    .then((response) => {
      setList(response.data.data.dados);
      setTotal(response.data.data.qtde);
      setLabels(response.data.labels);
      setIndexes(response.data.indexes);
      setLastPage(response.data.data.qtde, qtdePage);
      setListAll(response.data);
      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }
  
  function print () {
    setCarrying(true);
    if (!validForm()) {
      setCarrying(false);
      return false;
    }

    let data = {
      data: {
        product_de: filters.produtoDe.split('-')[0].trim(),
        product_ate: filters.produtoAte.split('-')[0].trim(),
        main_code_de: search_main_code_de,
        main_code_ate: search_main_code_ate,
        sub_code_de: search_sub_code_de,
        sub_code_ate: search_sub_code_ate,
        date_de: filters.dataDe,
        date_ate: filters.dataAte,
        print_coast: print_coast
      }
    };
    
    api.post("api/movements/print", data, {responseType: 'blob'}).then((response) => {
      const content = response.headers['content-type'];
      const dateAndHour = new Date();
      const formatedDateAndHour = format(dateAndHour, 'dd/MM/yyyy HH:mm:ss');

      download(response.data, `movimentações ${formatedDateAndHour}.xlsx`, content)
      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
      setCarrying(false);
    });
  }
  
  function nextPage () {
    if (limitPage != page) {
      setCarrying(true);
      
      let data = {
        data: {
          product_de: filters.produtoDe.split('-')[0].trim(),
          product_ate: filters.produtoAte.split('-')[0].trim(),
          main_code_de: search_main_code_de,
          main_code_ate: search_main_code_ate,
          sub_code_de: search_sub_code_de,
          sub_code_ate: search_sub_code_ate,
          date_de: filters.dataDe,
          date_ate: filters.dataAte,
          print_coast: print_coast,
          page: page+1,
          qtdePage: qtdePage,
        }
      };
      
      api.post("/api/movements/search", data)
      .then((response) => {
        setList(response.data.data.dados);
        setTotal(response.data.data.qtde);
        setLabels(response.data.labels);
        setIndexes(response.data.indexes);
        setCarrying(false);
        
        setPage(page+1);
        setQtdePage(qtdePage);
      }
      ).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function lastPage () {
    if (limitPage != page) {
      setCarrying(true);

      let data = {
        data: {
          product_de: filters.produtoDe.split('-')[0].trim(),
          product_ate: filters.produtoAte.split('-')[0].trim(),
          main_code_de: search_main_code_de,
          main_code_ate: search_main_code_ate,
          sub_code_de: search_sub_code_de,
          sub_code_ate: search_sub_code_ate,
          date_de: filters.dataDe,
          date_ate: filters.dataAte,
          print_coast: print_coast,
          page: limitPage,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/movements/search", data)
      .then((response) => {
        setList(response.data.data.dados);
        setTotal(response.data.data.qtde);
        setLabels(response.data.labels);
        setIndexes(response.data.indexes);
        setListAll(response.data);
        setCarrying(false);

        setPage(limitPage);
        setQtdePage(qtdePage);
      }).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function firstPage () {
    if (page != 1) {
      setCarrying(true);

      let data = {
        data: {
          product_de: filters.produtoDe.split('-')[0].trim(),
          product_ate: filters.produtoAte.split('-')[0].trim(),
          main_code_de: search_main_code_de,
          main_code_ate: search_main_code_ate,
          sub_code_de: search_sub_code_de,
          sub_code_ate: search_sub_code_ate,
          date_de: filters.dataDe,
          date_ate: filters.dataAte,
          print_coast: print_coast,
          page: 1,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/movements/search", data)
      .then((response) => {
        setList(response.data.data.dados);
        setTotal(response.data.data.qtde);
        setLabels(response.data.labels);
        setIndexes(response.data.indexes);
        setListAll(response.data);
        setCarrying(false);

        setPage(1);
        setQtdePage(qtdePage);
      }).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function previewPage () {
    if (page != 1) {
      setCarrying(true);

      let data = {
        data: {
          product_de: filters.produtoDe.split('-')[0].trim(),
          product_ate: filters.produtoAte.split('-')[0].trim(),
          main_code_de: search_main_code_de,
          main_code_ate: search_main_code_ate,
          sub_code_de: search_sub_code_de,
          sub_code_ate: search_sub_code_ate,
          date_de: filters.dataDe,
          date_ate: filters.dataAte,
          print_coast: print_coast,
          page: page-1,
          qtdePage: qtdePage,
        }
      };

      api.post("/api/movements/search", data)
      .then((response) => {
        setList(response.data.data.dados);
        setTotal(response.data.data.qtde);
        setLabels(response.data.labels);
        setIndexes(response.data.indexes);
        setListAll(response.data);
        setCarrying(false);

        setPage(page-1);
        setQtdePage(qtdePage);
      }).catch((error) => {
        showMessageError(error.response.data);
        setCarrying(false);
      });
    }
  }

  function verifySorts(itemOne, itemTwo){
    if(itemForSorting === 'observacao' || itemForSorting === 'nome_produto' || itemForSorting === 'main_code'){
      return itemOne[itemForSorting]?.toLowerCase()?.localeCompare(itemTwo[itemForSorting]?.toLowerCase());
    }

    if(itemForSorting === 'data'){
      return new Date(convertDateToAmericanFormat(itemOne[itemForSorting])) - new Date(convertDateToAmericanFormat(itemTwo[itemForSorting]));
    }

    return itemOne[itemForSorting] - itemTwo[itemForSorting];
  }

  function sortList(){    
    setList([...list].sort((a, b) => {
          if(sortingType !== 'Decrescente'){
            return verifySorts(a, b);
          }

          return verifySorts(b, a);
    }));
  }

  function associateLabelWithList(){
    let array = [];
    let newArray = [];

    list?.map((itemList) => {
      array.push(Object.entries(itemList));
    });

    array[0]?.map((object) => {
      labels?.map((label) => {
        if(object[0]?.replace(/[\s_.]/g, ' ')?.replace('id_', '').toLowerCase().includes(label?.toLowerCase().replace('id_', '').replace(/[\s_.]/g, ' '))){
          newArray?.push({label: label, item: object[0]});
        }
        
        if(object[0] === 'observacao' && label === 'OBS.'){
          newArray?.push({label: label, item: object[0]});
        }

        if(object[0] === 'nome_produto' && label === 'DESCRIÇÃO'){
          newArray?.push({label: label, item: object[0]});
        }

        if(object[0] === 'codigo_produto' && label === 'CÓD.'){
          newArray?.push({label: label, item: object[0]});
        }

        if(object[0] === 'id_requisicao' && label === 'REQUISIÇÃO'){
          newArray?.push({label: label, item: object[0]});
        }

        if(object[0] === 'quantidade' && label === 'QUANT.'){
          newArray?.push({label: label, item: object[0]});
        }
        
        if(object[0] === 'custo_medio' && label === 'CUSTO MÉDIO'){
          newArray?.push({label: label, item: object[0]});
        }
      });
    });

    setLabelsByList(newArray);
  }

  useEffect(() => {
    associateLabelWithList();
  }, [list, labels]);

  useEffect(() => {
    sortList();
  }, [sortingType, itemForSorting]);

  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
      
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Movimentações">
        </Title>

        <div className="container">
          <div className="containerGroupData">
            <h2>Filtros</h2>
            <hr></hr>

            <div className="divGroup">
              <div className="formDiv">
                <label>Data de</label>&nbsp;<label className="required">*</label><br/>
                <InputDate filters={filters} setFilters={setFilters} propertyFilter="dataDe" />
              </div>

              <div className="formDiv">
                <label>Data até</label>&nbsp;<label className="required">*</label><br/>
                <InputDate filters={filters} setFilters={setFilters} propertyFilter="dataAte" />
              </div>
              
              <div className="formDiv">
                <label>Main Code de</label><br/>
                <input type="text" placeholder="Main Code de" value={search_main_code_de} onChange={ (e) => setSearchMainCodeDe(e.target.value) } maxLength="20"/>
              </div>

              <div className="formDiv">
                <label>Main Code até</label><br/>
                <input type="text" placeholder="Main Code até" value={search_main_code_ate} onChange={ (e) => setSearchMainCodeAte(e.target.value) } maxLength="20"/>
              </div>
            </div>
            
            <div className="divGroup">
              <div className="formDiv">
                <label>Sub Code de</label><br/>
                <input type="text" placeholder="Sub Code de" value={search_sub_code_de} onChange={ (e) => setSearchSubCodeDe(e.target.value) } maxLength="20"/>
              </div>

              <div className="formDiv">
                <label>Sub Code até</label><br/>
                <input type="text" placeholder="Sub Code até" value={search_sub_code_ate} onChange={ (e) => setSearchSubCodeAte(e.target.value) } maxLength="20"/>
              </div>
              
              <ProductsInput filters={filters} setFilters={setFilters} productsFrom={productsFrom} setProductsFrom={setProductsFrom} productsUntil={productsUntil} setProductsUntil={setProductsUntil} />
            </div>
            
            <div className="divGroup">
              <div className="formDiv">
                <label>Imprime Custo</label><br/>
                <select value={print_coast} onChange={ (e) => setPrintCoast(e.target.value) } disabled={!averageCoastIsAllowed} >
                  <option value="">Selecione</option>
                  <option value="S">Sim</option>
                  <option value="N">Não</option>
                </select>
              </div>
            
              <div className="formDiv">
                <label>Itens por página</label><br/>
                <select value={qtdePage} onChange={(e) => {setQtdePage(e.target.value)}}>
                  <option value="500">Itens por página</option>
                  <option value="100">100</option>
                  <option value="200">200</option>
                  <option value="300">300</option>
                  <option value="400">400</option>
                  <option value="500">500</option>
                </select>
              </div>
              
              <div className="formDiv">
                <label>&nbsp;</label><br/>
                <button className="buttonInsertMargin" onClick={search}>
                  Pesquisar
                </button> 
                
                {labels.length > 1 && <div>
                  <button className="buttonInsert" onClick={print}>
                    Imprimir
                  </button> 
                </div>}
              </div>
            </div>
          </div>
          <br/>
          {labels.length > 1 && <div>
            <div className="divGroup">
              <table>
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    {labelsByList?.map((label, index) => {
                      return(
                          <th scope="col" key={index}>
                            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                              <p>{label?.label}</p>
                              <button style={{backgroundColor: 'inherit', fontSize: '1rem', marginLeft: '0.5rem', marginTop: '0.25rem', padding: '0', width: 'inherit', height: 'inherit'}}>
                                <RiArrowUpDownLine onClick={() => {sortingType === 'Crescente' ? setSortingType('Decrescente') : setSortingType('Crescente'); setItemForSorting(label?.item)}} />
                              </button>
                            </div>
                          </th>
                      )
                    })}
                  </tr>
                </thead>
                <tbody>
                  {list?.map((item, index)=> {
                    return(
                      <tr key={index}>
                        <td scope="col">{index+1}</td>
                        {indexes.map((label, i)=>{
                          return(
                            <td scope="col">{item[label]}</td>
                          )
                        })}
                      </tr>
                    )
                  })}
                  {list.length == 0 && <tr>
                    <td colSpan={7}><label className='required'>Nenhum registro encontrado!</label></td>
                  </tr>}
                </tbody>
              </table>
            </div>
            <br/>
            <div className="divGroupPagination">
                <button data-tip="Primeira página" type="button" onClick={firstPage} className="buttonFirstPage"><FaArrowLeft color="#001675" size={17} /><FaArrowLeft  color="#001675" size={17} /></button>
                <button data-tip="Página anterior" type="button" onClick={previewPage} className="buttonPreviewPage"><FaArrowLeft color="#001675" size={17} /></button>
                <div className="divLabelPagination">
                  <center><label className="labelPage">Exibindo página {page} de {limitPage} de um total de {total} registros</label></center>
                </div>
                <button data-tip="Próxima página" type="button" onClick={nextPage} className="buttonNextPage"><FaArrowRight color="#001675" size={17} /></button>
                <button data-tip="Última página" type="button" onClick={lastPage} className="buttonLastPage"><FaArrowRight color="#001675" size={17} /><FaArrowRight  color="#001675" size={17} /></button>
            </div>
          </div>}
        </div>
      </div>}
    </div>
  )
}